export function useCustomNavigate() {
  const navigate = (to: string) => {
    window.open(to, "_self");
  };

  return navigate;
}
